import React from 'react'

import './switch.less'

type Props = {
  enabled: boolean
}

const Switch: React.FC<Props> = ({ enabled }) => {
  return (
    <div className={`cookie-preference-switch ${enabled ? 'enabled' : 'disabled'}`}>
      <div></div>
    </div>
  )
}

export default Switch
